import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SharedUrlRoutes } from '@formbird/shared';
import { Observable, firstValueFrom } from 'rxjs';

const serverRoutes = SharedUrlRoutes.serverRoutes;

@Injectable({
  providedIn: 'root'
})
export class SessionTestService {
  private http = inject(HttpClient);


  async testSession(): Promise<any> {
    // returns an observable that shows whether the session to the server is connected
    return await firstValueFrom(this.testSessionObservable());
  }

  testSessionObservable(): Observable<any> {
    return this.http.get(serverRoutes.sessionTest, { responseType: 'text' });
  }


}
